import { ACTION_TYPES, PHASES, TURN_PHASES } from '../constants';
import {
  roll, chooseMove, stop, ackBust, canRoll, canStop, activePlayer, claimedCount,
} from './turnActions';

export { ACTION_TYPES, PHASES, TURN_PHASES };
export { canRoll, canStop, activePlayer, claimedCount };

/**
 * The single entry point for every state change: dispatch(state, action).
 *
 * Same shape as the sibling repos' engines - one reducer, plain JSON state
 * in and out, no framework imports anywhere under src/engine (enforced by
 * eslint). The UI never mutates state; it dispatches.
 *
 * An unknown or illegal action returns the state unchanged. Legality is the
 * caller's to check first (canRoll / canStop / the options list) - this is
 * the backstop, not the validation layer.
 */
export const dispatch = (state, action) => {
  if (!state || state.meta.phase !== PHASES.PLAYING) return state;

  switch (action?.type) {
    case ACTION_TYPES.ROLL:
      return roll(state);
    case ACTION_TYPES.CHOOSE_MOVE:
      return chooseMove(state, action.optionIndex);
    case ACTION_TYPES.STOP:
      return stop(state);
    case ACTION_TYPES.ACK_BUST:
      return ackBust(state);
    default:
      return state;
  }
};

export const rollAction = () => ({ type: ACTION_TYPES.ROLL });
export const chooseMoveAction = (optionIndex) => ({ type: ACTION_TYPES.CHOOSE_MOVE, optionIndex });
export const stopAction = () => ({ type: ACTION_TYPES.STOP });
export const ackBustAction = () => ({ type: ACTION_TYPES.ACK_BUST });

/**
 * Everything the UI needs about how a finished game came out. Null while the
 * game is still running, so a component can render on it directly.
 */
export const finalStandings = (state) => {
  if (!state || state.meta.phase !== PHASES.FINISHED) return null;
  return [...state.players]
    .map((p) => ({
      id: p.id,
      name: p.name,
      isBot: p.isBot,
      claimed: Object.entries(state.columns)
        .filter(([, owner]) => owner === p.id)
        .map(([column]) => Number(column)),
      isWinner: p.id === state.meta.winnerId,
    }))
    .sort((a, b) => (b.claimed.length - a.claimed.length));
};
